// @module NVT.AnnualApplicationFormE.AnnualApplicationFormE
define('NVT.AnnualApplicationFormE.AnnualApplicationFormE.View'
	, [
		'nvt_annualapplicationforme_annualapplicationforme.tpl'

		, 'NVT.AnnualApplicationFormE.AnnualApplicationFormE.SS2Model'

		, 'NVT.AnnualApplicationFormE.GlobalformUploadFile.View'

		, 'NVT.AnnualApplicationFormE.ReworkUploadDocuments.View'

		, 'NVT.AnnualApplicationFormE.DirecotorSignatureDocument.View'

		, 'Backbone'

		, 'Backbone.FormView'

		, 'GlobalViews.Message.View'

		, 'GlobalViews.Confirmation.View'

		, 'underscore'

		, 'jQuery'

		, 'Utils'

	]
	, function (
		nvt_annualapplicationforme_annualapplicationforme_tpl

		, AnnualApplicationFormESS2Model

		, GlobalformUploadFileView

		, ReworkUploadDocumentsView

		, DirecotorSignatureDocumentView

		, Backbone

		, BackboneFormView

		, MessageView

		, GlobalViewsConfirmationView

		, _

		, jQuery

		, Utils

	) {
		'use strict';

		var rec_internalid;

		// @class NVT.AnnualApplicationFormE.AnnualApplicationFormE.View @extends Backbone.View
		return Backbone.View.extend({

			template: nvt_annualapplicationforme_annualapplicationforme_tpl

			, initialize: function (options) {
				this.application = options.application;
				this.parentView = options.parentView;
				this.model = new AnnualApplicationFormESS2Model();
				BackboneFormView.add(this);
				var self = this;

				self.isDataAppear = {};
				self.globalmultipleuploadfilelist = [];
				self.uen_validation = true;
				self.otp_container = false;
				self.org_details = false;
				self.documents = false;
				self.signoff = false;
				self.contact = false;
				self.getcurrent_exemption_year = '';
				self.gmupfull_unaudited_acc_file = [];
				self.gmupannual_filling = [];
				self.gmupbizfile = [];
				self.gmupbizfile_second = [];
				self.gmupconsolidated_management_acc = [];
				self.gmupfull_audited_acc_file = [];
				self.gmupform_e2 = [];
				self.gmupdormant_as_per_acras_records = [];
				self.agreement = true;
				self.lttsofc ={
					lttsofc1 :false,
					lttsofc2 :false,
					lttsofc3 :false,
					lttsofc4 :false,
					lttsofc5 :false,
				} 
				self.isDataAppear.documentremark = '';
				self.isDataAppear.thatthecompanydid = false;
				self.isDataAppear.thatthenewlyincorporated = false;
				self.isDataAppear.is_director_registered_with_acra_options_yes = true;
				self.isDataAppear.is_director_registered_with_acra_options_no = false;	
				self.dataResponce = '';
				self.DraftApplication = {};
				self.draft_application_update = false;
			}


			, title: Utils.translate("Form E")

			, page_header: Utils.translate("Form E")

			, events: {

				'submit #formesubmitdraftapp': 'formesubmitdraftapp',

				'click button[data-action="is-draft-application"]': 'isDraftApplication',

				'click button[data-action="dynemic-multiple-upload-Remove"]': 'dynemicMultipleUploadRemove',

				'submit #isvalidateuen': 'saveTheForm',

				'keyup #uen': 'IsValidatedUen',

				'click [data-action="verify_otp_code"]': 'VerifyOtpCode',

				'click [data-action="application_btn_apply"]': 'applicationBtnApply',

				'change [data-action="getnnvalidexemptionyear"]': 'getInvalidExemptionYear',

				'submit #formesubmit': 'formesubmit',

				'click [data-action="next_step_process_second_back"]': 'nextStepProcessSecondBack',

				'click [data-action="cancel_btn"]': 'cancelotpsection',

				'click button[data-action="resendOtp"]': 'SendOtpOnEmail',

				'click a[data-action="dynemic-multiple-upload"]': 'dynemicMultipleUploadFile',

				'click [data-action="companystatustype"]': 'GetCompanyStatusType',

				'click [data-action="dyn-support-doc-upload"]':'dynemicSupportingDocumentUpload',

				'click [data-action="direcotorsignaturedocumentupload"]' : 'DirecotorSignatureDocumentupload',

				'click [data-action="data-action-please-tick-one"]': 'dataActionPleaseTickOne',

				'click [data-action="director_registered_with_acra_options"]' : 'ActionDirectorRegisteredWithAcraOptions',

				'click [data-action="data-action-forme2downloadpdf"]' : 'dwnattatthFormE2',
			}

			, dwnattatthFormE2: function(e)
			{
				e.preventDefault();
				var self = this;
				var current_exemption_year = self.getcurrent_exemption_year;
				var pre_exemption_year = self.getcurrent_exemption_year ? parseInt(self.getcurrent_exemption_year) - 1 : '';
				var FormESS2Model = new AnnualApplicationFormESS2Model();
				FormESS2Model.fetch({
					data: {
						'current_exemption_year': current_exemption_year,
						'pre_exemption_year': pre_exemption_year,
						'getmethod': 'downloadForme'
					}
				}).done(function (response) {
					var _getparm=document.createElement('a');
						_getparm.href=response;
						_getparm.target="_blank";
						_getparm.download="Form_E2";
						_getparm.click();
				});			 			  	        
			}    

			,	ActionDirectorRegisteredWithAcraOptions: function(e)
			{
				e.preventDefault();
				var self = this;
				var getcurrentvalue = e.currentTarget.value;

				if(getcurrentvalue == 'Yes')
				{
					self.isDataAppear.is_director_registered_with_acra_options_yes = true;
					self.isDataAppear.is_director_registered_with_acra_options_no = false;			
				}
				else{
					self.isDataAppear.is_director_registered_with_acra_options_yes = false;
					self.isDataAppear.is_director_registered_with_acra_options_no = true;		
				}	
				self.bindAllparameter();
				self.render();
			}

			,	dataActionPleaseTickOne: function(e)
			{
				e.preventDefault();
				var self = this;
				var getcurrentvalue = e.currentTarget.value;
				
				if(getcurrentvalue == '1')
				{
					self.isDataAppear.thatthecompanydid = true;
					self.isDataAppear.thatthenewlyincorporated =false;			
				}
				else{
					self.isDataAppear.thatthecompanydid = false;
					self.isDataAppear.thatthenewlyincorporated =true;		
				}	
				self.bindAllparameter();
				self.render();
			}

			,	GetCompanyStatusType : function(e)
			{
				var self = this;
				self.isDataAppear.documentremark = jQuery("#documentremark").val();
				this.getcurrentindexval = e.currentTarget.value;
					self.globalmultipleuploadfilelist = [];
					self.agreement = true;
				if(this.getcurrentindexval == '1'){        
					self.agreement = true;       
					self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 0 === i);
					self.lttsofc = { lttsofc1 :true,
						lttsofc2 :false,
						lttsofc3 :false,
						lttsofc4 :false,
						lttsofc5 :false,
					} 
				}
				else if(this.getcurrentindexval == '2') {               
					self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 1 === i);
					self.lttsofc ={
						lttsofc1 :false,
						lttsofc2 :true,
						lttsofc3 :false,
						lttsofc4 :false,
						lttsofc5 :false,
					} 
				}
				else if(this.getcurrentindexval == '3'){               
					self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 2 === i);
					self.lttsofc = { lttsofc1 :false,
						lttsofc2 :false,
						lttsofc3 :true,
						lttsofc4 :false,
						lttsofc5 :false,
					} 
				}
				else if(this.getcurrentindexval == '4'){               
					self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 3 === i);
					self.lttsofc = { lttsofc1 :false,
						lttsofc2 :false,
						lttsofc3 :false,
						lttsofc4 :true,
						lttsofc5 :false,
					} 
				}
				else if(this.getcurrentindexval == '5'){               
					self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 4 === i);
					self.lttsofc = { lttsofc1 :false,
						lttsofc2 :false,
						lttsofc3 :false,
						lttsofc4 :false,
						lttsofc5 :true,
					} 
				}
				else {               
					//self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 2 === i);
					self.lttsofc ={
						lttsofc1 :false,
						lttsofc2 :false,
						lttsofc3 :false,
						lttsofc4 :false,
						lttsofc5 :false,
					} 
				}

				self.bindAllparameter();
				self.render();
			}
		
			, cancelotpsection: function (e) {
				var self = this;
				self.uen_validation = true;
				self.otp_container = false;
				self.org_details = false;
				self.documents = false;
				self.draft_application_update = false;
				self.render();
			}

			, nextStepProcessSecondBack: function (e) {
				var self = this;
				self.org_details = true;
				self.documents = false;
				self.show_message_submited = false;
				self.dataResponce = '';
				self.DraftApplication = {};
				self.draft_application_update = false;

				self.isDataAppear.documentremark = '';
				self.isDataAppear.thatthecompanydid = false;
				self.isDataAppear.thatthenewlyincorporated = false;
				self.isDataAppear.is_director_registered_with_acra_options_yes = true;
				self.isDataAppear.is_director_registered_with_acra_options_no = false;	

				self.isDataAppear.signature =  '';
				self.isDataAppear.director_name =  '';
				self.isDataAppear.contact_name =  '';
				self.isDataAppear.designation =  '';
				self.isDataAppear.contact_email =  '';
				self.isDataAppear.phone =  '';
				self.isDataAppear.submittedby =  '';
				self.isDataAppear.sub_by_desig =  '';
				self.isDataAppear.submittedemail =  '';
				self.isDataAppear.sub_by_phone =  '';

				self.getMembExempList();
				self.render();
			}

			, dynemicMultipleUploadRemove: function (e) {
				e.preventDefault();
				var self = this;
				var id = jQuery(e.target).val();
				if (id) {
					var selectedMUFRemove = self.globalmultipleuploadfilelist.filter(function (muf) { if (muf.id != id) { return muf; } });
					self.globalmultipleuploadfilelist = selectedMUFRemove;
					self.render();
				}
			}

			, validateEmail: function (email) {

				var self = this;
				var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
				return re.test(email);
			},

			bindAllparameter: function(e)
			{
				var self = this;
				self.isDataAppear.documentremark = jQuery("#documentremark").val();
				self.isDataAppear.signature = jQuery("#signature").val();
				self.isDataAppear.director_name = jQuery("#director_name").val();
				self.isDataAppear.contact_name = jQuery("#contact_name").val();
				self.isDataAppear.designation = jQuery("#designation").val();
				self.isDataAppear.contact_email = jQuery("#contact_email").val();
				self.isDataAppear.phone = jQuery("#phone").val();
				self.isDataAppear.submittedby = jQuery("#submittedby").val();
				self.isDataAppear.sub_by_desig = jQuery("#sub_by_desig").val();
				self.isDataAppear.submittedemail = jQuery("#submittedemail").val();
				self.isDataAppear.sub_by_phone = jQuery("#sub_by_phone").val();
			}

			, formesubmit: function (e) {
				var self = this,
					$target = jQuery(e.target),
					getfielddata = $target.serializeObject();

				self.gmupfull_unaudited_acc_file = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "full_unaudited_acc_file"});
				self.gmupannual_filling = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "annual_filling"});
				self.gmupbizfile = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId === "bizfile"});
				self.gmupbizfile_second = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId === "bizfile_second"});
				self.gmupconsolidated_management_acc = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "consolidated_management_acc"});
				self.gmupfull_audited_acc_file = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "full_audited_acc_file"});
				self.gmupform_e2 = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "form_e2"});
				self.gmupdormant_as_per_acras_records = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "dormant_as_per_acras_records"});
				var getyearselected = self.otphasbeensend[0].current_exemption_year_id;

				// if (!getfielddata.exemption_year) {
				// 	self.showMessage('Exemption Year is required', 'error', 'exemption_year');
				// }
				//else 
				if ($('input[name="status_options"]:checked').val() == '' || $('input[name="status_options"]:checked').val() == null) {
					self.showMessage('Type of company is required', 'error', 'status_options');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '4' && self.gmupbizfile_second.length ==0) {
					self.showMessage('Documents is required', 'error', 'bizfile_second');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '4' && self.gmupform_e2.length ==0) {
					self.showMessage('Documents is required', 'error', 'form_e2');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '1' && self.gmupbizfile.length == 0) {
					self.showMessage('Documents is required', 'error', 'bizfile');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '1' && self.gmupconsolidated_management_acc.length == 0){
					self.showMessage('Documents is required', 'error', 'consolidated_management_acc');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '2' && self.gmupfull_audited_acc_file.length == 0){
					self.showMessage('Documents is required', 'error', 'full_audited_acc_file');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '3' && self.gmupfull_unaudited_acc_file.length == 0) {
					self.showMessage('Documents is required', 'error', 'full_unaudited_acc_file');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '3' && self.gmupannual_filling.length == 0) {
					self.showMessage('Documents is required', 'error', 'annual_filling');
					return false;
				}
				else if ($('input[name="status_options"]:checked').val() == '5' && self.gmupdormant_as_per_acras_records.length == 0) {
					self.showMessage('Documents is required', 'error', 'dormant_as_per_acras_records');
					return false;
				}
				else if(!$('input[name="thatthenewlyincorporated"]:checked').val() && !$('input[name="thatthecompanydid"]:checked').val())
				{
					self.showMessage('Please choose any one for option', 'error', 'thatthenewlyincorporated');
					return false;					
				}
				// else if (!getfielddata.signature && getfielddata.is_director_registered_with_acra_options == 'Yes') {
				// 	self.showMessage('Signature is required', 'error', 'signature');
				// 	return false;
				// }
				else if (!getfielddata.signature && self.isDataAppear.is_director_registered_with_acra_options_yes == true) {
					self.showMessage('Signature is required', 'error', 'signature');
					return false;
				}
				else if (!getfielddata.director_name) {
					self.showMessage('Director name is required', 'error', 'director_name');
					return false;
				}
				else if (!getfielddata.contact_name) {
					self.showMessage('Contact name is required', 'error', 'contact_name');
					return false;
				}
				else if (!getfielddata.designation) {
					self.showMessage('Designation is required', 'error', 'designation');
					return false;
				}
				else if (!getfielddata.phone) {
					self.showMessage('Phone is required', 'error', 'phone');
					return false;
				}
				else if (!self.validateEmail(getfielddata.contact_email.trim())) {
					self.showMessage('The email address is required.', 'error', 'contact_email');
					return false;
				}
				else if (!getfielddata.submittedby) {
					self.showMessage('Person Submitted By is required.', 'error', 'submittedby');
					return false;
				}
				else if (!self.validateEmail(getfielddata.submittedemail.trim())) {
					self.showMessage('The email address is required.', 'error', 'submittedemail');
					return false;
				}
				else if (!getfielddata.sub_by_desig) {
					self.showMessage('Job Title is required.', 'error', 'sub_by_desig');
					return false;
				}
				else if (!getfielddata.sub_by_phone) {
					self.showMessage('Phone Number is required.', 'error', 'sub_by_phone');
					return false;
				}
				else {
					getfielddata['is_director_registered_with_acra_options'] = self.isDataAppear.is_director_registered_with_acra_options_yes === true ? 'Yes' : 'No';
					var ststus = true;
					var model = new AnnualApplicationFormESS2Model();
					model.fetch({
						async: false,
						type: 'POST',
						data: {  isDraftApplication:JSON.stringify(self.DraftApplication) , data: JSON.stringify(getfielddata), mfu: JSON.stringify(self.globalmultipleuploadfilelist),customData : JSON.stringify(getyearselected),folderlocfile:JSON.stringify(SC.CONFIGURATION.AnnualApplicationFormE.config)},
					}).done(function (responce) {
						if (responce.successMessage) {
							self.documents = false;
							self.org_details = false;
							self.show_number = responce.id;
							self.dataResponce = responce;
							self.show_message_submited = responce.is_director_registered_with_acra_options === false;
							self.render();
						}
						else {
							self.showMessage(responce.errorMessage, 'error')
							ststus = false;
						}
					})
					return ststus;
				}
			}

			, DirecotorSignatureDocumentupload: function (e) {
				e.preventDefault();
				var self = this;
				var model = new AnnualApplicationFormESS2Model();
				var application = this.application;
				var Layout = application.getLayout();
				var view = new DirecotorSignatureDocumentView({
					application: application,
					model: model,
					getmemid: e.target.id
				});

				Layout.showInModal(view);
				view.model.on('reset sync remove change destroy', function (model) {
					
					var getappsnumbers = model.get('appsnumbers') || '';

					if(getappsnumbers)
					{
						self.documents = false;
						self.org_details = false;
						self.show_number = getappsnumbers;
						self.dataResponce = '';
						self.show_message_submited = true;
						self.render();
					}
					else{
						self.getMembExempList();
					}					
				});
			}

			, dynemicSupportingDocumentUpload: function (e) {
				e.preventDefault();
				var self = this;
				var model = new AnnualApplicationFormESS2Model();
				var application = this.application;
				var Layout = application.getLayout();
				var view = new ReworkUploadDocumentsView({
					application: application,
					model: model,
					getmemid: e.target.id
				});

				Layout.showInModal(view);
				view.model.on('reset sync remove change destroy', function (model) {
					self.getMembExempList();
				});
			}

			, dynemicMultipleUploadFile: function (e) {
				e.preventDefault();
				var self = this;
				var model = new AnnualApplicationFormESS2Model();
				var application = this.application;
				var Layout = application.getLayout();
			
				// number of uploaded files does not exceed the limit
				var maxFilesAllowed = 5;
				var currentFileCount = self.globalmultipleuploadfilelist.length;
				self.bindAllparameter();
				if (currentFileCount >= maxFilesAllowed) {
					const getlay1 = self.application.layout;
					var view = new GlobalViewsConfirmationView({
						title: "Alert",
						body: Utils.translate('You can only upload a maximum of 5 files.'),
						class: 'hidden',
						autohide: true
					});
					getlay1.showInModal(view);
					return false;
				}
			
				// Continue with the file upload process if the limit is not reached
				var view = new GlobalformUploadFileView({
					application: application,
					model: model,
					profile: '', //self.otphasbeensend[0] || '',
					globalmultipleuploadfilelist: self.globalmultipleuploadfilelist,
					getfileId: e.target.id
				});
			
				Layout.showInModal(view);
				view.model.on('reset sync remove change destroy', function (model) {
					self.render();
				});
			}

			, VerifyOtpCode: function (e) {
				e.preventDefault();
				var self = this;
				var otpvode = '';
				jQuery(".otp-inputs-container > input").each(function () {
					if ($(this).val()) {
						otpvode += $(this).val();
					}
				});

				if (otpvode) {
					this.model = new AnnualApplicationFormESS2Model();
					this.model.fetch({
						async: false, data: {
							'getmethod': 'VerifyOtpCode',
							'otpvode': otpvode,
							'contactId': self.otphasbeensend[0].contactId || '',
						},
					}).done(function (result) {
						if (result == true) {
							self.otp_container = false;
							self.org_details = true;
							var _list_A = self.getMembExempList();
							self.render();
						}
						else {
							const getlay1 = self.application.layout;
							var view = new GlobalViewsConfirmationView({
								title: "Invalid OTP",
								body: Utils.translate('The verification code that you have entered is incorrect. Please try again.'),
								class: 'hidden',
								autohide: true
							});
							getlay1.showInModal(view);
						}
					});
				}
				else {
					const getlay1 = self.application.layout;
					var view = new GlobalViewsConfirmationView({
						title: "Invalid OTP",
						body: Utils.translate('The verification code that you have entered is incorrect. Please try again.'),
						class: 'hidden',
						autohide: true
					});
					getlay1.showInModal(view);
				}
			}

			, SendOtpOnEmail: function () {
				var self = this;
				if (self.otphasbeensend[0].contactId) {
					var FormESS2Model = new AnnualApplicationFormESS2Model();
					FormESS2Model.fetch({
						data: {
							'param': self.otphasbeensend[0].contactId || '',
							'orgname': self.otphasbeensend[0].orgname || '',
							'getmethod': 'SendOtpOnEmail'
						}
					}).done(function (response) {
						self.render();
					});
				}
			}


			, getInvalidExemptionYear: function (e) {

				e.preventDefault();
				var self = this;
				self.getcurrent_exemption_year = jQuery("#exemption_year option:selected").text();
				if(self.getcurrent_exemption_year)
				{
					self.otphasbeensend[0].ListExemptionYearCustom.map(obj => {
						if (obj.name === self.getcurrent_exemption_year) {
						  obj.selected = true; // Set this object to true
						} else {
						  obj.selected = false; // Set all others to false
						}
						return obj; // Return the modified object
					});
				}
			}

			, applicationBtnApply: function () {
				
				var self = this;
					self.getcurrent_exemption_year = jQuery("#exemption_year option:selected").text();

				if (self.getcurrent_exemption_year) {
					var getIsthereyears = self.getMembershipExemptionList.filter(function (yearss) {
						return yearss.year_for_exemption == self.getcurrent_exemption_year && yearss.status_of_app != ""
					});

					if (getIsthereyears.length > 0) {
						const getlay1 = self.application.layout;
						var view = new GlobalViewsConfirmationView({
							title: "Invalid",
							body: Utils.translate('You have already submitted an application for this year. Please select a different year to proceed.'),
							class: 'hidden',
							autohide: true
						});
						getlay1.showInModal(view);
					}
					else {
						self.getcurrent_exemption_year = jQuery("#exemption_year option:selected").text();
						self.otphasbeensend[0].current_exemption_year = self.getcurrent_exemption_year;
						self.otphasbeensend[0].current_exemption_year_id = jQuery("#exemption_year").val();
						self.org_details = false;
						self.documents = true;
						self.render();
					}
				}
			}

			, saveTheForm: function (e) {

				var self = this,
					$target = jQuery(e.target),
					getfielddata = $target.serializeObject();

				if (!getfielddata.uen) {
					self.showMessage('UEN number is required', 'error', 'uen');
					return false;
				}
				else if (!getfielddata.email.trim()) {
					self.showMessage('The email address is required.', 'error', 'email');
					return false;
				}
				else if (!self.validateEmail(getfielddata.email.trim())) {
					self.showMessage('The email address must be properly formatted.', 'error', 'email');
					return false;
				}
				else {
					var promise = BackboneFormView.saveForm.apply(this, arguments);

					return promise && promise.then
						(
							function (responce) {
								if (responce[0].successMessage) {
									self.showMessage(responce[0].successMessage, 'success');
									self.otphasbeensend = responce;
									self.uen_validation = false;
									self.otp_container = true;
									self.render();
								}
								else {
									const getlay1 = self.application.layout;
									var view = new GlobalViewsConfirmationView({
										title: "Invalid",
										body: Utils.translate(responce[0].errorMessage),
										class: 'hidden',
										autohide: true
									});
									getlay1.showInModal(view);
									//self.showMessage(responce[0].errorMessage, 'error')
								}

								return false;
							}
						);
				}

			}

			, showMessage: function (message, type, field) {
				jQuery('.global-views-message-error').remove();
				jQuery('.global-views-message-success').remove();

				var messageView = new MessageView
					({
						message: message
						, type: type
						, closable: type == 'error' ? true : false
					});
				if (typeof field !== 'undefined') {
					this.options.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
				}
				else if (type == 'error') {
					this.options.application.getLayout().$('form').append(messageView.render().$el);
				}
				else {
					this.options.application.getLayout().$('form').append(messageView.render().$el);
				}
			}

			, IsValidatedUen: function (e) {
				e.preventDefault();
				var self = this;
				var getcurrentvalue = jQuery('#uen').val().trim();
				if (getcurrentvalue) {
					var FormESS2Model = new AnnualApplicationFormESS2Model();
					FormESS2Model.fetch({
						data: {
							'uen_no': getcurrentvalue,
							'method': 'checkUENnumberIsValid'
						}
					})
						.done(function (response) {
							//	self.isnonMember =  response[0].isvalidSaturityMember;

							if (response.length === 0) {
								self.showMessage("The UEN you entered was not found in our records. Please contact exemption@sbf.org.sg for further clarification.", 'error', 'uen');
							}
							else if (response[0].membershiptype_text !== 'Statutory Member') {
								self.showMessage("Based on the UEN entered, the company is not eligible to apply for exemption. Please contact us at exemption@sbf.org.sg for further assistance.", 'error', 'uen');
							}
							else {
								self.IsValidatedUenList = response;
								jQuery('.global-views-message-error').remove();
								for (var n = 0; n < response.length; n++) {
									jQuery("input[name='organisationname']").val(response[0].name);
								}
							}
						});
				}
			}

			, getMembExempList: function () {
				var self = this;
				self.getMembershipExemptionList = [];
				if (self.org_details) {
					var getcurrentvalue = self.otphasbeensend.length > 0 ? self.otphasbeensend[0].orgId : '';
					var FormESS2Model = new AnnualApplicationFormESS2Model();
					FormESS2Model.fetch({
						data: {
							'orgId': getcurrentvalue,
							'getmethod': 'getMembershipExemptionList'
						}
					})
						.done(function (response) {
							self.getMembershipExemptionList = response;
							self.render();
						});
				}
			}

			, isDraftApplication: function (e) {
				var self = this;
					self.listInforDraftApp = [];
					self.DraftApplication = {};
					var getcurrentvalue = e.currentTarget.id;
					var getcurrentname = e.currentTarget.value;
				if (getcurrentvalue && getcurrentname) {
					self.DraftApplication.getUpdateId = getcurrentvalue;
					self.DraftApplication.getUpdateName = getcurrentname;
					self.DraftApplication.actionType = 'updatedraftapp';
					var FormESS2Model = new AnnualApplicationFormESS2Model();
					FormESS2Model.fetch({
						data: {
							'getid': getcurrentvalue,
							'getname': getcurrentname,
							'getmethod': 'getinformdraftapp'
						}
					}).done(function (response) {
						if(response.length > 0)
						{
							self.listInforDraftApp = response[0];
							self.isDataAppear.documentremark = self.listInforDraftApp.ams_remark;

							this.getcurrentindexval = self.listInforDraftApp.type_status_com;
								self.globalmultipleuploadfilelist = [];
								self.agreement = true;
							if(this.getcurrentindexval == '1'){        
								self.agreement = true;       
								self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 0 === i);
								self.lttsofc = { lttsofc1 :true,
									lttsofc2 :false,
									lttsofc3 :false,
									lttsofc4 :false,
									lttsofc5 :false,
								} 
							}
							else if(this.getcurrentindexval == '2') {               
								self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 1 === i);
								self.lttsofc ={
									lttsofc1 :false,
									lttsofc2 :true,
									lttsofc3 :false,
									lttsofc4 :false,
									lttsofc5 :false,
								} 
							}
							else if(this.getcurrentindexval == '3'){               
								self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 2 === i);
								self.lttsofc = { lttsofc1 :false,
									lttsofc2 :false,
									lttsofc3 :true,
									lttsofc4 :false,
									lttsofc5 :false,
								} 
							}
							else if(this.getcurrentindexval == '4'){               
								self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 3 === i);
								self.lttsofc = { lttsofc1 :false,
									lttsofc2 :false,
									lttsofc3 :false,
									lttsofc4 :true,
									lttsofc5 :false,
								} 
							}
							else if(this.getcurrentindexval == '5'){               
								self.otphasbeensend[0].ListTypeStatusofCompany.forEach((item, i) => item.isselected = 4 === i);
								self.lttsofc = { lttsofc1 :false,
									lttsofc2 :false,
									lttsofc3 :false,
									lttsofc4 :false,
									lttsofc5 :true,
								} 
							}
							else {               
								self.lttsofc ={
									lttsofc1 :false,
									lttsofc2 :false,
									lttsofc3 :false,
									lttsofc4 :false,
									lttsofc5 :false,
								} 
							}


							if(self.listInforDraftApp.emp_validat == '1')
							{
								self.isDataAppear.thatthecompanydid = true;
								self.isDataAppear.thatthenewlyincorporated =false;			
							}
							else{
								self.isDataAppear.thatthecompanydid = false;
								self.isDataAppear.thatthenewlyincorporated =true;		
							}	

							self.isDataAppear.director_name = self.listInforDraftApp.name_of_dir;
							self.isDataAppear.contact_name = self.listInforDraftApp.contact_person;
							self.isDataAppear.designation = self.listInforDraftApp.job_title;
							self.isDataAppear.contact_email = self.listInforDraftApp.contact_email;
							self.isDataAppear.phone = self.listInforDraftApp.contact_number;
							self.isDataAppear.submittedby = self.listInforDraftApp.application_sub_by;
							self.isDataAppear.sub_by_desig = self.listInforDraftApp.sub_by_desig;
							self.isDataAppear.submittedemail = self.listInforDraftApp.ubmitted_by_email;
							self.isDataAppear.sub_by_phone = self.listInforDraftApp.sub_by_bus_tele;

							self.getcurrent_exemption_year = self.listInforDraftApp.year_for_exemption_text;
							self.otphasbeensend[0].current_exemption_year = self.getcurrent_exemption_year;
							self.otphasbeensend[0].current_exemption_year_id = self.listInforDraftApp.year_for_exemption_id;
							
							self.org_details = false;
							self.draft_application_update = true;
							self.render();
						}
						else{
							self.draft_application_update = false;
							self.DraftApplication = {};
						}
					});
				}
			}

			, formesubmitdraftapp: function (e) {
				var self = this,
					$target = jQuery(e.target),
					getfielddata = $target.serializeObject();
				var getyearselected = self.otphasbeensend[0].current_exemption_year_id;
				
				if (!getfielddata.director_name) {
					self.showMessage('Director name is required', 'error', 'director_name');
					return false;
				}
				else if (!getfielddata.contact_name) {
					self.showMessage('Contact name is required', 'error', 'contact_name');
					return false;
				}
				else if (!getfielddata.designation) {
					self.showMessage('Designation is required', 'error', 'designation');
					return false;
				}
				else if (!getfielddata.phone) {
					self.showMessage('Phone is required', 'error', 'phone');
					return false;
				}
				else if (!self.validateEmail(getfielddata.contact_email.trim())) {
					self.showMessage('The email address is required.', 'error', 'contact_email');
					return false;
				}
				else if (!getfielddata.submittedby) {
					self.showMessage('Person Submitted By is required.', 'error', 'submittedby');
					return false;
				}
				else if (!self.validateEmail(getfielddata.submittedemail.trim())) {
					self.showMessage('The email address is required.', 'error', 'submittedemail');
					return false;
				}
				else if (!getfielddata.sub_by_desig) {
					self.showMessage('Job Title is required.', 'error', 'sub_by_desig');
					return false;
				}
				else if (!getfielddata.sub_by_phone) {
					self.showMessage('Phone Number is required.', 'error', 'sub_by_phone');
					return false;
				}
				else {
					var ststus = true;
					var model = new AnnualApplicationFormESS2Model();
					model.fetch({
						async: false,
						type: 'POST',
						data: { isDraftApplication:JSON.stringify(self.DraftApplication) ,data: JSON.stringify(getfielddata), mfu: JSON.stringify(self.globalmultipleuploadfilelist),customData : JSON.stringify(getyearselected),folderlocfile:JSON.stringify(SC.CONFIGURATION.AnnualApplicationFormE.config)},
					}).done(function (responce) {
						if (responce.successMessage) {
							self.DraftApplication = {};
							self.draft_application_update = false;
							self.show_number = responce.id;
							self.dataResponce = responce;
							self.show_message_submited = false;
							
							self.isDataAppear.documentremark = '';
							self.isDataAppear.thatthecompanydid = false;
							self.isDataAppear.thatthenewlyincorporated = false;
							self.isDataAppear.is_director_registered_with_acra_options_yes = true;
							self.isDataAppear.is_director_registered_with_acra_options_no = false;	

							self.isDataAppear.signature =  '';
							self.isDataAppear.director_name =  '';
							self.isDataAppear.contact_name =  '';
							self.isDataAppear.designation =  '';
							self.isDataAppear.contact_email =  '';
							self.isDataAppear.phone =  '';
							self.isDataAppear.submittedby =  '';
							self.isDataAppear.sub_by_desig =  '';
							self.isDataAppear.submittedemail =  '';
							self.isDataAppear.sub_by_phone =  '';
							self.render();
						}
						else {
							self.showMessage(responce.errorMessage, 'error')
							ststus = false;
						}
					})
					return ststus;
				}
			}

			, bindings: {

			}

			, childViews: {

			}

			//@method getContext @return NVT.AnnualApplicationFormE.AnnualApplicationFormE.View.Context
			, getContext: function getContext() {
				//@class NVT.AnnualApplicationFormE.AnnualApplicationFormE.View.Context
				var self = this;
					self.gmupfull_unaudited_acc_file = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "full_unaudited_acc_file"});
					self.gmupannual_filling = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "annual_filling"});
					self.gmupbizfile = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId === "bizfile"});
					self.gmupbizfile_second = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId === "bizfile_second"});
					self.gmupconsolidated_management_acc = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "consolidated_management_acc"});
					self.gmupfull_audited_acc_file = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "full_audited_acc_file"});
					self.gmupform_e2 = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "form_e2"});
					self.gmupdormant_as_per_acras_records = self.globalmultipleuploadfilelist.filter(function (el) {return el.getfileId == "dormant_as_per_acras_records"});
				
				return {
					otphasbeensend: self.otphasbeensend || '',
					uen_validation: self.uen_validation,
					otp_container: self.otp_container,
					sca_org_details: self.org_details,
					sca_documents: self.documents,
					signoff: self.signoff,
					contact: self.contact,
					show_message_submited: self.show_message_submited,
					show_number: self.show_number || '',
					getMembershipExemptionList: self.getMembershipExemptionList,
					gmuploadfilelist: self.globalmultipleuploadfilelist || [],
					gmupfull_unaudited_acc_file : self.gmupfull_unaudited_acc_file,
					gmupannual_filling: self.gmupannual_filling ,
					gmupbizfile: self.gmupbizfile ,
					gmupbizfilesecond: self.gmupbizfile_second ,
					gmupconsolidated_management_acc: self.gmupconsolidated_management_acc ,
					gmupfull_audited_acc_file: self.gmupfull_audited_acc_file ,
					gmupform_e2: self.gmupform_e2 ,
					gmupdormant_as_per_acras_records: self.gmupdormant_as_per_acras_records,
					current_exemption_year: self.getcurrent_exemption_year,
					pre_exemption_year: self.getcurrent_exemption_year ? parseInt(self.getcurrent_exemption_year) - 1 : '',
					lttsofc :self.lttsofc ,
					selfAgreement:self.agreement,
					isDataAppear : self.isDataAppear ,
					dataResponce : self.dataResponce || '',
					draft_application_update: self.draft_application_update,
					membershipexemptionhelplink : SC.CONFIGURATION.AnnualApplicationFormE.helplink || ''
				};
			}
		});
	});
